import React from 'react';
import { useTranslations } from 'next-intl';
import AffiliateBenefitsItem from './AffiliateBenefitsItem';
import AfiwaTag from '@/ui/shared/components/afiwaTag';
import Image from 'next/image';
import SectionHeading from '@/ui/shared/components/sectionHeading';

type AffiliateBenefitsItemProps = {
  icon: string;
  title: string;
  description: string;
};

function AffiliationsBenefits() {
  const affiliateProgramText = useTranslations(
    'affiliate_program.affiliation_benefits',
  );

  const BenefitsList: AffiliateBenefitsItemProps[] = [
    {
      title: affiliateProgramText('generous_comissions'),
      description: affiliateProgramText('generous_comissions_description'),
      icon: '/icons/generous-commissions-icon.svg',
    },
    {
      title: affiliateProgramText('flexible'),
      description: affiliateProgramText('flexible_description'),
      icon: '/icons/flexible-icon.svg',
    },
    {
      title: affiliateProgramText('support_ressources'),
      description: affiliateProgramText('support_ressources_description'),
      icon: '/icons/support-ressources-icon.svg',
    },
  ];
  return (
    <div className="app-container my-16 flex flex-col justify-center gap-y-10 md:my-20 md:gap-y-16">
      <div className="mx-auto flex flex-col items-center justify-center gap-y-5">
        <AfiwaTag text={affiliateProgramText('benefits')}></AfiwaTag>

        <SectionHeading className=" text-center font-extrabold text-primary">
          {affiliateProgramText('why_affiliate')}
        </SectionHeading>
      </div>
      <div className="grid grid-cols-1 gap-y-10 md:grid-cols-3 md:gap-5 md:gap-y-0">
        {BenefitsList.map((benefit, index) => (
          <AffiliateBenefitsItem
            key={index}
            title={benefit.title}
            description={benefit.description}
            icon={
              <Image
                src={benefit.icon}
                alt={benefit.title}
                width={86}
                height={87}
                className="md:w32 h-20 w-20 md:h-32"
              />
            }
          />
        ))}
      </div>
    </div>
  );
}

export default AffiliationsBenefits;
